<template>
  <div ref="formContainer">
    <br><br>
    <div class="card card-body p-0" style="border-radius: 10px">
      <admin-log-table :users="users" :totalPages="totalPages" :page="page" @setPage="setPage" :setSkeletonLoader="displayLoader"></admin-log-table>
    </div>
  </div>
</template>

<script>
  import helpers from "@/helpers.js";
  import AdminLogTable from "./admin_logs_table";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  import axios from "axios";

  export default {
    components: {
      AdminLogTable,VueSkeletonLoader
    },

    data: function () {
      return {
        page: 0,
        fullPage: "",
        organization_search: "all",
        users: "",
        displayLoader: true,
      };
    },

    async created() {
      this.page = helpers.getPageQuery();
      this.setSkeletonLoader(true);
       const permission = {
        headers: {
          'X-Permission': 'admin_users_log_list' 
        }
      };
      await axios.get("/admin/users/test?page="+this.page,permission).then((response) => {
        this.users = response.data.data;
        this.totalPages = Math.ceil(response.data.total / 100);
        // this.setSkeletonLoader(false);
      });
      
    },
    computed: {
      // totalPages: function () {
      //   return this.$store.getters["users/totalPages"];
      // },
    },
    watch: {
      page: function (val) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.setSkeletonLoader(true);
          const permission = {
        headers: {
          'X-Permission': 'admin_users_log_list' 
        }
      };
        axios.get("/admin/users/test?page="+this.page,permission).then(() => {
          // loader.hide();
          setTimeout(() => {
          // loader.hide();
            this.setskeletonLoader(false);
          },2500);
        });
      },
    },
    methods: {
      setPage(page, organization_search) {
        this.page = page;
        this.organization_search = organization_search;
        this.$router.push("admin-log?page=" + page);
      },
      setSkeletonLoader(val){
        this.displayLoader = val;
      },
    },
  };
</script>
<style>
  .custom_all {
    position: absolute;
    z-index: 999;
    top: 350px;
    left: 40%;
    opacity: 0.5;
  }
</style>